var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSelectArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#select-arrow_svg__clip0_3_2)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#696E77",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m9.243 4.243-3 3-3-3"
}))));
export default SvgSelectArrow;